import dcsLogo from '../../assets/dcs-logo.svg'
import heromamaLogo from '../../assets/heromama-logo.png'
import ladynLogo from '../../assets/ladyn-logo.png'
import lmLogo from '../../assets/lm-logo.svg'
import shepherdLogo from '../../assets/shepherdtech-logo.png'
import style from '../../style/components/client-home.module.scss'

export const ClientHome = () => {
  return (
    <div className={style.root}>
      <div className={style.header}>
        <img className={style['header-logo']} src={shepherdLogo} alt="shepherd-logo" />
      </div>
      <div className={style.content}>
        <p className={style.title}>活動尚未開始，請至牧羊人集團各品牌進行下單</p>
        <div className={style.cards}>
          <a href="https://www.dogcatstar.com" className={style.card}>
            <img className={style['card-img']} src={dcsLogo} alt="dcs-logo" />
          </a>
          <a href="https://litomon.com" className={style.card}>
            <img className={style['card-img']} src={lmLogo} alt="lm-logo" />
          </a>
          <a href="https://heromamapet.com" className={style.card}>
            <img className={style['card-img']} src={heromamaLogo} alt="heromama-logo" />
          </a>
          <a href="https://ladynpet.com" className={style.card}>
            <img className={style['card-img']} src={ladynLogo} alt="ladyn-logo" />
          </a>
        </div>
      </div>
      <div className={style.footer}>
        <p className={style.copyright}>
          牧羊人貿易有限公司
          <br />
          HONG KONG HUNG HOM KLN MAN YUE ST KAISER EST NO 41 RM 2 UNIT A2, 6F
          <br />
          營業時間：周一至周五 09: 30-18: 00
          <br />
          客服 Whatsapp ID：+886 983 537 932
          <br />
          Copyright © 2024 Shepherd trading limited., LTD. All rights reserved.
        </p>
      </div>
    </div>
  )
}
